import React from 'react';
import { Headset, Ticket, RefreshCcw, Award, QrCode, ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';

export default function ValueProps() {
  const props = [
    { icon: Headset, title: '24/7 CUSTOMER CARE', subtitle: '100% Secure Transactions', color: 'text-pink-500', bg: 'bg-pink-50', hoverBg: 'group-hover:bg-pink-500' },
    { icon: Ticket, title: 'INSTANT BOOKING', subtitle: 'Quick Ticketing', color: 'text-purple-500', bg: 'bg-purple-50', hoverBg: 'group-hover:bg-purple-500' },
    { icon: RefreshCcw, title: 'EASY REFUNDS', subtitle: 'Hassle-Free Process', color: 'text-blue-500', bg: 'bg-blue-50', hoverBg: 'group-hover:bg-blue-500' },
    { icon: Award, title: 'OFFICIAL ONLY', subtitle: 'Verified & Trusted', color: 'text-emerald-500', bg: 'bg-emerald-50', hoverBg: 'group-hover:bg-emerald-500' },
    { icon: QrCode, title: 'DIGITAL TICKET', subtitle: 'Paperless Entry', color: 'text-amber-500', bg: 'bg-amber-50', hoverBg: 'group-hover:bg-amber-500' },
    { icon: ShieldCheck, title: '100% GENUINE', subtitle: 'Official Partner', color: 'text-indigo-500', bg: 'bg-indigo-50', hoverBg: 'group-hover:bg-indigo-500' },
  ];

  return (
    <motion.div 
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="hidden md:block max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6 mb-6"
    >
      <div className="bg-white rounded-3xl p-8 md:p-10 flex flex-col md:flex-row justify-between items-center shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100">
        {props.map((prop, index) => {
          const Icon = prop.icon;
          return (
            <React.Fragment key={index}>
              <div className="flex flex-col items-center flex-1 my-4 md:my-0 group cursor-pointer w-full">
                <div className={`w-12 h-12 rounded-2xl ${prop.bg} ${prop.color} flex items-center justify-center mb-4 transition-all duration-300 ${prop.hoverBg} group-hover:text-white group-hover:shadow-md group-hover:-translate-y-1`}>
                  <Icon size={24} strokeWidth={1.5} />
                </div>
                <h4 className="font-extrabold text-gray-800 text-[10px] sm:text-[11px] tracking-wider text-center transition-colors group-hover:text-gray-900">{prop.title}</h4>
                <p className="text-[9px] text-gray-400 mt-1.5 uppercase font-bold text-center tracking-wide">{prop.subtitle}</p>
              </div>
              
              {/* Divider for desktop */}
              {index < props.length - 1 && (
                <div className="hidden md:block w-px h-16 bg-gray-100 mx-2"></div>
              )}
              
              {/* Divider for mobile */}
              {index < props.length - 1 && (
                <div className="md:hidden w-3/4 h-px bg-gray-100 my-4 mx-auto"></div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </motion.div>
  );
}
